import { Patient } from '@dataTypes/PatientInfo.types'

export const mockPatients: Patient[] = [
  {
    patient_id: 'mock-patient-1',
    first_name: 'John Mark',
    middle_name: 'Kennedy',
    last_name: 'Doe',
    date_of_birth: '1985-05-15',
    address: '123 Main Street',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    gender: 'Male',
    marital_status: 'Single',
    profession: 'Software Engineer',
    company_name: 'Tech Corp',
    cellphone: '555-0101',
    home_phone: '555-0102',
    work_phone: '555-0103',
    fax_number: '555-0104',
    email: 'john.doe@example.com',
    allergy_ids: ['mock-allergy-0', 'mock-allergy-1', 'mock-allergy-2'],
    patient_allergies: [
      {
        allergy_id: 'mock-allergy-0',
        allergy: { allergy_id: 'mock-allergy-0', title: 'Penicillin' },
      },
      {
        allergy_id: 'mock-allergy-1',
        allergy: { allergy_id: 'mock-allergy-1', title: 'Latex' },
      },
      {
        allergy_id: 'mock-allergy-2',
        allergy: { allergy_id: 'mock-allergy-2', title: 'Shellfish' },
      },
    ],
    medical_condition_ids: [
      'mock-condition-0',
      'mock-condition-1',
      'mock-condition-2',
    ],
    patient_medical_conditions: [
      {
        medical_condition_id: 'mock-condition-0',
        medical_condition: {
          medical_condition_id: 'mock-condition-0',
          title: 'Hypertension',
        },
      },
      {
        medical_condition_id: 'mock-condition-1',
        medical_condition: {
          medical_condition_id: 'mock-condition-1',
          title: 'Diabetes Type 2',
        },
      },
      {
        medical_condition_id: 'mock-condition-2',
        medical_condition: {
          medical_condition_id: 'mock-condition-2',
          title: 'Asthma',
        },
      },
    ],
    has_insurance: true,
    insurance_provider: 'Blue Cross, Blue Shield',
    policy_number: 'BC123456',
    insurance_expiry_date: '2025-12-31',
    join_referral_program: false,
    preferred_appointment_time: 'Morning',
    contact_via_phone: true,
    contact_via_sms: true,
    contact_via_email: true,
    contact_via_app: false,
    preferred_provider: 'mock-provider-1',
    preferred_hygienist: 'mock-provider-2',
    preferredProvider: {
      provider_id: 'mock-provider-1',
      first_name: 'John',
      middle_name: 'Michael',
      last_name: 'Smith',
      work_role: 'Dentist',
    },
    preferredHygienist: {
      provider_id: 'mock-provider-2',
      first_name: 'Sarah',
      middle_name: 'Elizabeth',
      last_name: 'Johnson',
      work_role: 'Hygienist',
    },
    preferred_provider_name: 'John Smith',
    preferred_hygienist_name: 'Sarah Johnson',
    notes: '',
    uploadedFiles: [],
    template: '',
    contact_via: ['phone', 'sms', 'email'],
    photo: 'https://cdn-icons-png.flaticon.com/512/1920/1920990.png',
    membership_type: 'Silver',
  },
  {
    patient_id: 'mock-patient-2',
    first_name: 'Jane Marie',
    middle_name: 'Johnson',
    last_name: 'Smith',
    date_of_birth: '1990-08-22',
    address: '456 Oak Avenue',
    city: 'Los Angeles',
    state: 'CA',
    zip: '90001',
    gender: 'Female',
    marital_status: 'Married',
    profession: 'Dentist',
    company_name: 'Dental Care Clinic',
    cellphone: '555-0202',
    email: 'jane.smith@example.com',
    allergy_ids: [],
    patient_allergies: [],
    medical_condition_ids: [],
    patient_medical_conditions: [],
    has_insurance: true,
    insurance_provider: 'Blue Shield',
    policy_number: 'AE789012',
    join_referral_program: true,
    preferred_appointment_time: 'Afternoon',
    contact_via_phone: true,
    contact_via_sms: false,
    contact_via_email: true,
    contact_via_app: true,
    notes: '',
    uploadedFiles: [],
    template: '',
    contact_via: ['phone', 'email', 'app'],
    photo: 'https://cdn-icons-png.flaticon.com/512/1921/1921103.png',
    membership_type: 'Gold',
  },
]
